/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useState as e,useEffect as o}from"react";import{env as f}from"../utils/env.js";function t(){let[t,r]=e(f.isHandoffComplete);return t&&!1===f.isHandoffComplete&&r(!1),o((()=>{!0!==t&&r(!0)}),[t]),o((()=>f.handoff()),[]),t}export{t as useServerHandoffComplete};
//# sourceMappingURL=use-server-handoff-complete.js.map
